import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Select from "react-select";
import { Row } from "react-bootstrap";

import find from "lodash/find";

export const RS_THEME = {
  LIGHT: {
    borderRadius: 4,
    colors: {
      primary: "#2684FF",
      primary75: "#4C9AFF",
      primary50: "#B2D4FF",
      primary25: "#DEEBFF",
      danger: "#DE350B",
      dangerLight: "#FFBDAD",
      neutral0: "hsl(0, 0%, 100%)",
      neutral5: "hsl(0, 0%, 95%)",
      neutral10: "hsl(0, 0%, 90%)",
      neutral20: "hsl(0, 0%, 80%)",
      neutral30: "hsl(0, 0%, 70%)",
      neutral40: "hsl(0, 0%, 60%)",
      neutral50: "hsl(0, 0%, 50%)",
      neutral60: "hsl(0, 0%, 40%)",
      neutral70: "hsl(0, 0%, 30%)",
      neutral80: "hsl(0, 0%, 20%)",
      neutral90: "hsl(0, 0%, 10%)"
    },
    spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 }
  },
  DARK: {
    borderRadius: 4,
    colors: {
      primary: "#d8dbe2",
      primary75: "#004473",
      primary50: "#50accb",
      primary25: "#007cb1",
      danger: "#DE350B",
      dangerLight: "#FFBDAD",

      text: "hsl(0, 0%, 100%)",
      neutral90: "hsl(0, 0%, 95%)",
      neutral80: "hsl(0, 0%, 90%)",
      neutral70: "hsl(0, 0%, 80%)",
      neutral60: "hsl(0, 0%, 70%)",
      neutral50: "hsl(0, 0%, 60%)",
      neutral40: "hsl(0, 0%, 50%)",
      neutral30: "hsl(0, 0%, 40%)",
      neutral20: "hsl(0, 0%, 30%)",
      neutral10: "hsl(0, 0%, 20%)",
      neutral5: "hsl(0, 0%, 10%)",
      neutral0: "#202832"
      // neutral0: "#202832",
    },
    spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 }
  }
};

const DropdownSearch = ({
  name,
  data,
  value,
  disabled,
  placeholder,
  required,
  onChange,
  isNightMode
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const obj = find(data, { value });
    setSelected(obj);
  }, [data, value]);

  return (
    <Row className="form-group">
      <Select
        required={required}
        name={name}
        value={selected || ""}
        onChange={(v) => onChange(name, v)}
        options={data}
        placeholder={placeholder || "Please Select..."}
        validations="isFalse"
        validationErrors={{}}
        isSearchable
        isDisabled={disabled}
        theme={(theme) =>
          isNightMode
            ? {
                ...theme,
                ...RS_THEME.DARK
              }
            : {
                ...theme,
                ...RS_THEME.LIGHT
              }
        }
        // menuIsOpen
      />
    </Row>
  );
};

DropdownSearch.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  data: PropTypes.array,
  required: PropTypes.bool,
  isNightMode: PropTypes.bool
};

export default DropdownSearch;
